import { render } from "./cloudflare_video.vue?vue&type=template&id=63ee220e&scoped=true"
import script from "./cloudflare_video.vue?vue&type=script&lang=js"
export * from "./cloudflare_video.vue?vue&type=script&lang=js"

import "./cloudflare_video.vue?vue&type=style&index=0&id=63ee220e&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ee220e"]])

export default __exports__